import React from "react";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import { CgWebsite } from "react-icons/cg";
import { BsGithub } from "react-icons/bs";

function ProjectCards({ imgPath, title, description, ghLink, demoLink, isBlog }) {
  return (
    <Card className="project-card-view">
      <Card.Img variant="top" src={imgPath} alt={`${title} screenshot`} />
      <Card.Body>
        <Card.Title>{title}</Card.Title>
        <Card.Text style={{ textAlign: "justify" }}>{description}</Card.Text>

        {/* Only rendered when there is somewhere to go. Previously this button
            was always drawn, so every card with no ghLink showed a dead
            "GitHub" button pointing at href={undefined}. */}
        {ghLink && (
          <Button variant="primary" href={ghLink} target="_blank" rel="noreferrer">
            <BsGithub /> &nbsp;
            {isBlog ? "Blog" : "GitHub"}
          </Button>
        )}

        {!isBlog && demoLink && (
          <Button
            variant="primary"
            href={demoLink}
            target="_blank"
            rel="noreferrer"
            style={{ marginLeft: ghLink ? "10px" : "0" }}
          >
            <CgWebsite /> &nbsp;Visit Site
          </Button>
        )}
      </Card.Body>
    </Card>
  );
}

export default ProjectCards;
